import { appTheme } from '@signaturit/react-components-library';
import { Theme } from '@material-ui/core/styles';

export type BrandingProps = {
    theme: Theme;
    metatagTitle: string;
};

const getBrand = (url: string): string => url?.split('.')[1];

export const getBrandingProps = (url: string = 'app.signaturit.com'): BrandingProps => {
    return { theme: appTheme, metatagTitle: 'default.metatags.title' };
};

export const isCoe = (url: string = 'app.signaturit.com'): boolean => {
    const brand: string = getBrand(url);

    return ['coe', 'sigint'].includes(brand);
};
